import { useKeycloak } from "@react-keycloak/web";
import Axios, { AxiosInstance } from "axios";
import { createContext, createElement, useMemo } from "react";
import Qs from "qs";
import { getBaseURL } from "./helpers";

export const AxiosContext = createContext<AxiosInstance>(Axios);

export const AxiosProvider = ({children}: any) => {

    const {keycloak} = useKeycloak();

    const auth = useMemo(() => {
        const axios = Axios.create({
            baseURL: getBaseURL(),
            paramsSerializer: params => Qs.stringify(params, {arrayFormat: 'repeat'})
        });
      
        axios.interceptors.request.use(async (config) => {
            if (keycloak.token && keycloak.authenticated) {
                try {
                    await keycloak.updateToken(30);
                } catch (error) {
                    console.error("Token refresh failed:", error);
                }

                if (!config.headers.Authorization) {
                    config.headers.Authorization = `Bearer ${keycloak.token}`;
                    config.headers['p365-tenant-url-identifier'] = window.location.pathname.split('/')[1]
                }
            }

            return config;
        })
        return axios;
    }, [keycloak.authenticated, keycloak.token])

    return createElement(AxiosContext.Provider, {value: auth}, children);
}
